
import { Options, Vue } from 'vue-class-component'
import '@/assets/styles/custom.css';
import $ from 'jquery';
export default class Footer extends Vue{
  mounted() {
    $('.en').hide()
    $('.th').show()
  }
}
